import React, { useState } from 'react'
import Swal from 'sweetalert2'
import apiClient, { API_ENDPOINTS } from '../../config/api'

const AddSupplier = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: ''
  })
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      // Prepare payload
      const payload = {
        name: formData.name.trim(),
        email: formData.email.trim() || null,
        phone: formData.phone.trim() || null,
        address: formData.address.trim() || null
      }

      // Remove null values
      Object.keys(payload).forEach(key => {
        if (payload[key] === null || payload[key] === '') {
          delete payload[key]
        }
      })

      await apiClient.post(API_ENDPOINTS.SUPPLIERS, payload)

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Supplier created successfully!',
        confirmButtonText: 'OK'
      })

      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        address: ''
      })
    } catch (error) {
      console.error('Error creating supplier:', error)
      const errorMessage = error.response?.data?.name?.[0] || 
                          error.response?.data?.non_field_errors?.[0] ||
                          error.response?.data?.detail ||
                          error.response?.data?.message ||
                          'Failed to create supplier. Please try again.'
      
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className="pagetitle">
        <h1>Add Supplier</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item">Suppliers</li>
            <li className="breadcrumb-item active">Add Supplier</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-truck me-2"></i>
                  Add New Supplier
                </h5>

                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <label htmlFor="name" className="col-sm-2 col-form-label">Supplier Name <span className="text-danger">*</span></label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Enter supplier name"
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label htmlFor="email" className="col-sm-2 col-form-label">Email</label>
                    <div className="col-sm-10">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Enter email address (Optional)"
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label htmlFor="phone" className="col-sm-2 col-form-label">Phone</label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Enter phone number (Optional)"
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label htmlFor="address" className="col-sm-2 col-form-label">Address</label>
                    <div className="col-sm-10">
                      <textarea
                        className="form-control"
                        id="address"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="Enter supplier address (Optional)"
                        rows="3"
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-sm-10 offset-sm-2">
                      <button 
                        type="submit" 
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Creating...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-plus-circle me-2"></i>
                            Create Supplier
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AddSupplier

